module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_3.85f0058f.png";